export type SwishType = 'mcommerce' | 'ecommerce'

export const swishTypes: Record<SwishType, SwishType> = {
  mcommerce: 'mcommerce',
  ecommerce: 'ecommerce'
};
